import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Inverter, License } from '../../shared';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useSelector } from '../../store/utils';

export const InverterTypeSelect = ({
  value,
  onChange,
}: {
  value: Inverter;
  onChange: (value: Inverter) => void;
}) => {
  const [legacyInverters, boardRS485, license] = useSelector(
    (s) =>
      [
        s.variables.LEGACY_INVERTERS,
        s.variables.BOARD_RS485,
        s.variables.LICENSE,
      ] as const
  );

  const showLegacyInverters =
    legacyInverters || value === Inverter.GoodWeGridNext;

  return (
    <FormControl>
      <InputLabel id="inverter-type-label">
        <FormattedMessage
          id="settings.service.inverter_type.label"
          defaultMessage="Střídač"
        />
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as Inverter)}
        labelId="inverter-type-label"
        size="medium"
        label={
          <FormattedMessage
            id="settings.service.inverter_type.label"
            defaultMessage="Střídač"
          />
        }
      >
        <MenuItem value={Inverter.GoodWeNext} key={Inverter.GoodWeNext}>
          <FormattedMessage id="inverter.good_we" defaultMessage="GoodWe" />
        </MenuItem>
        {showLegacyInverters && (
          <MenuItem
            value={Inverter.GoodWeGridNext}
            key={Inverter.GoodWeGridNext}
          >
            <FormattedMessage
              id="inverter.good_we_grid_next"
              defaultMessage="GoodWe síťový"
            />
          </MenuItem>
        )}
        <MenuItem value={Inverter.SolaxNext} key={Inverter.SolaxNext}>
          <FormattedMessage id="inverter.solax" defaultMessage="Solax" />
        </MenuItem>
        {license === License.INDUSTRIAL && (
          <MenuItem value={Inverter.SolaxEMS1000} key={Inverter.SolaxEMS1000}>
            <FormattedMessage
              id="inverter.solax_ems1000"
              defaultMessage="Solax EMS1000"
            />
          </MenuItem>
        )}
        {license === License.INDUSTRIAL && (
          <MenuItem
            value={Inverter.SolaxEMS1000PRO}
            key={Inverter.SolaxEMS1000PRO}
          >
            <FormattedMessage
              id="inverter.solax_ems1000pro"
              defaultMessage="Solax EMS1000PRO"
            />
          </MenuItem>
        )}
        <MenuItem value={Inverter.SolaxMICGrid} key={Inverter.SolaxMICGrid}>
          <FormattedMessage
            id="inverter.solax_mic_grid"
            defaultMessage="Solax MIC síťový"
          />
        </MenuItem>
        <MenuItem value={Inverter.SolaxMEGAGrid} key={Inverter.SolaxMEGAGrid}>
          <FormattedMessage
            id="inverter.solax_mega_grid"
            defaultMessage="Solax MEGA/FORTH síťový"
          />
        </MenuItem>
        <MenuItem value={Inverter.Victron} key={Inverter.Victron}>
          <FormattedMessage id="inverter.victron" defaultMessage="Victron" />
        </MenuItem>
        <MenuItem value={Inverter.Solinteg} key={Inverter.Solinteg}>
          <FormattedMessage id="inverter.solinteg" defaultMessage="Solinteg" />
        </MenuItem>
        <MenuItem value={Inverter.Deye} key={Inverter.Deye}>
          <FormattedMessage id="inverter.deye" defaultMessage="Deye LV" />
        </MenuItem>
        <MenuItem value={Inverter.DeyeHV} key={Inverter.DeyeHV}>
          <FormattedMessage id="inverter.deye_hv" defaultMessage="Deye HV" />
        </MenuItem>
        <MenuItem value={Inverter.Wattsonic} key={Inverter.Wattsonic}>
          <FormattedMessage
            id="inverter.wattsonic"
            defaultMessage="Wattsonic"
          />
        </MenuItem>
        <MenuItem
          value={Inverter.SofarSolarRS485}
          key={Inverter.SofarSolarRS485}
        >
          <FormattedMessage
            id="inverter.sofar_solar_rs485"
            defaultMessage="SofarSolar RS485"
          />
        </MenuItem>
        <MenuItem
          value={Inverter.DesBatteryContainer}
          key={Inverter.DesBatteryContainer}
        >
          <FormattedMessage
            id="inverter.des_battery_container"
            defaultMessage="DES - kontejnerové úložiště"
          />
        </MenuItem>
        {boardRS485 && (
          <MenuItem value={Inverter.Hes} key={Inverter.Hes}>
            <FormattedMessage
              id="inverter.hes"
              defaultMessage="HES - bateriové úložiště"
            />
          </MenuItem>
        )}
        <MenuItem value={Inverter.Fronius} key={Inverter.Fronius}>
          <FormattedMessage
            id="inverter.fronius"
            defaultMessage="Fronius SYMO GEN24"
          />
        </MenuItem>
        <MenuItem value={Inverter.FroniusGrid} key={Inverter.FroniusGrid}>
          <FormattedMessage
            id="inverter.fronius_grid"
            defaultMessage="Fronius SYMO síťový"
          />
        </MenuItem>
        <MenuItem value={Inverter.FroniusVerto} key={Inverter.FroniusVerto}>
          <FormattedMessage
            id="inverter.fronius_verto"
            defaultMessage="Fronius Verto"
          />
        </MenuItem>
        <MenuItem value={Inverter.SmaGrid} key={Inverter.SmaGrid}>
          <FormattedMessage
            id="inverter.sma_grid"
            defaultMessage="SMA síťový"
          />
        </MenuItem>
        <MenuItem value={Inverter.SolarEdgeGrid} key={Inverter.SolarEdgeGrid}>
          <FormattedMessage
            id="inverter.solar_edge_grid"
            defaultMessage="SolarEdge síťový"
          />
        </MenuItem>
        <MenuItem value={Inverter.Sermatec} key={Inverter.Sermatec}>
          <FormattedMessage id="inverter.sermatec" defaultMessage="Sermatec" />
        </MenuItem>
        <MenuItem value={Inverter.None} key={Inverter.None}>
          <FormattedMessage id="inverter.none" defaultMessage="Žádný" />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
